import { render, staticRenderFns } from "./courseUserDetail.vue?vue&type=template&id=619c3fd4"
import script from "./courseUserDetail.vue?vue&type=script&lang=js"
export * from "./courseUserDetail.vue?vue&type=script&lang=js"
import style0 from "./courseUserDetail.vue?vue&type=style&index=0&id=619c3fd4&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports